import { FC } from "react";
import classNames from "classnames";
import { locale } from "src/config/app-config";
import styles from "./Footer.module.scss";
import { FooterBottom } from "./FooterBottom";

interface Props {
  className?: string;
}

const FooterLegal: FC<Props> = ({ className }) => (
  <footer className={classNames(styles.wrapper, className)}>
    <FooterBottom locale={locale} hideLanguageSwitcher />
  </footer>
);

export { FooterLegal };
